/* eslint-disable camelcase */
import Vue from 'vue';
import qs from 'qs';
import dayjs from 'dayjs';

function getPreviewEl (el) {
    const previewElClass = 'v-md-editor-preview';

    return el.classList.contains(previewElClass) ? el : el.querySelector(`.${previewElClass}`);
}

export default function createPlugin () {
    async function handleMdChange () {
        if (typeof window === 'undefined') return;

        await this.$nextTick();

        const previewEl = getPreviewEl(this.$el);
        const eles = previewEl.querySelectorAll('.v-md-pre-wrapper-gpt-chatbox-flow-prediction');
        if (!eles.length) return;

        let ele = eles[0];
        if (!ele || !ele.innerText) return;

        try {
            let text = ele.innerText;
            ele.innerText = '';

            let url = text.trim();
            let query = qs.parse(url.substring(url.indexOf('?') + 1));
            let resp = await fetch(url);
            let json = await resp.json();

            if (!json) {
                ele.innerText = '未识别数据';
                return;
            }

            let compName = null;
            let data = null;
            let time = query.current_time;
            let n1time = [dayjs(time).format('HH:mm:ss'), dayjs(time).add(-1, 'hour').format('HH:mm:ss'), dayjs(time).add(-2, 'hour').format('HH:mm:ss')];
            let n2time = [dayjs(time).add(1, 'hour').format('HH:mm:ss'), dayjs(time).add(2, 'hour').format('HH:mm:ss'), dayjs(time).add(3, 'hour').format('HH:mm:ss')];
            if (!query || !query.chartType || query.chartType === 'chart-table') {
                compName = 'gpt-chart-table';
                data = [
                    { '时间': '时间', '进站客流量': '进站客流量', '出站客流量': '出站客流量' }
                ];
                let n1 = json['过去出站客流量'].length;
                let n2 = json['未来出站客流量'].length;
                for (let i = n1 - 1; i >= 0; i--) {
                    data.push({
                        '时间': n1time[i],
                        '进站客流量': json['过去进站客流量'][i],
                        '出站客流量': json['过去出站客流量'][i]
                    });
                }
                for (let i = 0; i < n2; i++) {
                    data.push({
                        '时间': n2time[i],
                        '进站客流量': json['未来进站客流量'][i],
                        '出站客流量': json['未来出站客流量'][i]
                    });
                }
            } else {
                compName = 'gpt-' + query.chartType;
                data = [];
                for (let i = json['过去进站客流量'].length - 1; i >= 0; i--) {
                    let val = json['过去进站客流量'][i];
                    data.push({ SERIES: '进站客流量', CATEGORY: n1time[i], VALUE: val });
                };
                for (let i = json['过去出站客流量'].length - 1; i >= 0; i--) {
                    let val = json['过去出站客流量'][i];
                    data.push({ SERIES: '出站客流量', CATEGORY: n1time[i], VALUE: val });
                }
                for (let i = 0; i < json['未来进站客流量'].length; i++) {
                    let val = json['未来进站客流量'][i];
                    data.push({ SERIES: '进站客流量', CATEGORY: n2time[i], VALUE: val });
                };
                for (let i = 0; i < json['未来出站客流量'].length; i++) {
                    let val = json['未来出站客流量'][i];
                    data.push({ SERIES: '出站客流量', CATEGORY: n2time[i], VALUE: val });
                };
            }

            if (data && compName) {
                let propsData = { value: data };// 组件初始化时传入绑定数据（propsData只能用于初始化，复发响应式）

                let Comp = Vue.component(compName);
                if (!Comp) {
                    throw new Error(`Component ${compName} not found`);
                }
                let comp = new Comp({ propsData });
                comp.$mount(ele);
            } else {
                ele.innerText = '未识别数据';
            }
        } catch (err) {
            console.error(err);
            ele.innerText = '分析过程中出现错误';
        }
    }

    return {
        install (VMdEditor) {
            if (!VMdEditor.mixins) VMdEditor.mixins = [];

            VMdEditor.mixins.push({
                watch: {
                    value: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    text: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    currentMode: handleMdChange
                }
            });
        }
    };
};
